import "./FullWidthContainer.scss";
export default function ArrayDisplayContainer({ title, index, value = [] }) {
  return (
    <div className="full_width_tile_container">
      <div className="title">{title}</div>
      <ul className="value">
        {value.length == 0 ? '-' :
          value.map((item, idx) => (
            <li key={idx}>{item[index]}</li>
          ))}
      </ul>

    </div>
  );
}
